module.exports = __webpack_public_path__ + "img/connecting.62f469ab.gif";